// extracted by mini-css-extract-plugin
module.exports = {"disclosureCheckbox":"_17lOiJMO","disclosureLabel":"EL-SrgW4"};